import { emptyGuid } from './empty-guid';

export function isNullOrEmpty(
	value: string | null | undefined
): value is null | undefined {
	if (value === undefined) {
		return true;
	} else if (value === null) {
		return true;
	} else if (value.length === 0) {
		return true;
	} else if (value.trim() === emptyGuid()) {
		return true;
	} else {
		return value.trim() === '';
	}
}
